<template>
    <div>
        <v-card
            v-if="attachment || contact_card_id"
            class="attachment-card"
            outlined
        >
            <v-card-text class="pa-2">
                <div class="d-flex align-center justify-space-between">
                    <div
                        v-if="attachment"
                        class="d-flex align-center"
                    >
                        <v-avatar
                            size="48"
                            class="image-thumbnail mr-2"
                            tile
                            @click="show_image_dialog = true"
                        >
                            <v-tooltip bottom>
                                <template #activator="{ on, attrs }">
                                    <img
                                        :src="$rc.blobURL(attachment.object_name)"
                                        :alt="attachment.natural_filename"
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <span>View larger preview</span>
                            </v-tooltip>
                        </v-avatar>
                        <span class="text-caption attachment-label">{{ attachment.natural_filename }}</span>
                    </div>

                    <div
                        v-else-if="contact_card_id"
                        class="d-flex align-center"
                    >
                        <v-icon
                            size="24"
                            class="mr-2"
                            aria-hidden="true"
                        >
                            mdi-card-account-details
                        </v-icon>
                        <span class="text-caption attachment-label">{{ vcard_label || 'Contact Card' }}</span>
                    </div>

                    <v-tooltip
                        v-if="allow_edit"
                        bottom
                    >
                        <template #activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                class="ml-3"
                                :disabled="has_sent"
                                v-bind="attrs"
                                v-on="on"
                                icon
                                x-small
                                @click="$emit('edit')"
                            >
                                <v-icon
                                    aria-hidden="true"
                                    small
                                >
                                    mdi-lead-pencil
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Edit {{ attachment ? 'image' : 'contact card' }} attachment</span>
                    </v-tooltip>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog
            v-if="attachment"
            v-model="show_image_dialog"
            max-width="800px"
            content-class="image-lightbox-dialog"
        >
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center pa-4 mb-0 card-title-with-bg">
                    <span class="text-h6">{{ attachment.natural_filename }}</span>
                    <v-btn
                        aria-label="Close dialog"
                        icon
                        @click="show_image_dialog = false"
                    >
                        <v-icon aria-hidden="true">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="px-4 pb-6">
                    <div class="d-flex justify-center">
                        <img
                            :src="$rc.blobURL(attachment.object_name)"
                            :alt="attachment.natural_filename"
                            class="lightbox-image"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'BulkMessageMediaPreview',

    props: {
        attachment: {
            type: Object,
        },
        contact_card_id: {
            type: String,
        },
        has_sent: {
            type: Boolean,
            default: false,
        },
        allow_edit: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            show_image_dialog: false,
            vcard_label: '',
        };
    },

    methods: {
        getVCardInternalLabelById() {
            this.$rc.rest(
                'LIST: /api/v1/vcard',

                { vcard_id: this.contact_card_id },

                (data) => {
                    if (!data.results?.length) {
                        this.vcard_label = '';
                        return;
                    }

                    this.vcard_label = data.results[0].internal_label;
                },

                () => {
                    this.vcard_label = '';
                    return;
                },
            );
        }
    },

    watch: {
        contact_card_id: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.getVCardInternalLabelById();
                } else {
                    this.vcard_label = '';
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.attachment-card {
    min-width: 160px;
    flex: 1;
    height: 100%;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: none;

    .v-card__text {
        border-radius: var(--border-radius-default);
    }

    .attachment-label {
        line-height: 1.2;
    }

    .image-thumbnail {
        cursor: pointer;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 0.8;
        }
    }
}

:deep(.v-avatar img) {
    object-fit: contain;
}

:deep(.image-lightbox-dialog) {
    .lightbox-image {
        max-width: 100%;
        max-height: 70vh;
        object-fit: contain;
        display: block;
    }
}
</style>